

















import Vue from 'vue'
import BrandButton from './BrandButton.vue';
export default Vue.extend({
  components: { BrandButton },
	computed: {
		base() : string {
			return window.location.origin;
		},
		parent() {
			return this.$route.path.substring(0, this.$route.path.lastIndexOf("/"));
		}
	}
})
